module.exports = __webpack_public_path__ + "static/media/Mobile.253a7142.svg";